/* eslint no-underscore-dangle: ["error", { "allow": ["_root"] }] */
// need this eslint rule since griddle now produces dangling vars...

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Griddle, {
  plugins,
  RowDefinition,
  ColumnDefinition,
} from 'griddle-react';
import { Link, withRouter } from 'react-router';
import _ from 'lodash';

import { Dialog, FlatButton } from 'material-ui';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import Divider from 'material-ui/Divider';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import EditIcon from 'material-ui/svg-icons/content/create';
import DeleteIcon from 'material-ui/svg-icons/action/delete';

import caseInsensitiveSort from '../../../helpers/caseInsensitiveSort';
import { addFeedback } from '../../../store/modules/feedback';

import classes from './ServiceKey.scss';

const mapActionCreators = {
  addFeedback,
};

const mapStateToProps = state => ({});

const renderCell = data => (
  <Link to={`/serviceKey/${data.value._root.entries[1][1]}`}>
    {data.value._root.entries[0][1]}
  </Link>
);

const prepareData = (dataArray, fetching) => {
  const newData = [];

  _.forOwn(dataArray, value => {
    if (value.deleted_at === null || typeof value.deleted_at !== 'undefined') {
      newData.push({
        id: value.id,
        link: {
          title: value.name,
          id: value.id,
        },
        createdDate: value.createdDate,
        description: value.description,
        typelength: value.types.length,
      });
    }
  });

  return newData;
};

class ServiceKey extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null,
    };
  }

  componentDidMount() {
    this.props.fetchServiceKey();
  }

  componentWillReceiveProps(nextProps) {
    if (typeof nextProps.params.servicekey !== 'undefined') {
      if (nextProps.params.servicekey.length) {
        this.props.setServiceKeyForm(nextProps.params.servicekey);
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(nextState) !== JSON.stringify(this.state)) {
      return true;
    }

    if (
      JSON.stringify(
        _.omit(nextProps, [
          'fetchServiceKey',
          'deleteServiceKey',
          'setServiceKeyForm',
          'addFeedback',
        ]),
      ) !==
      JSON.stringify(
        _.omit(this.props, [
          'fetchServiceKey',
          'deleteServiceKey',
          'setServiceKeyForm',
          'addFeedback',
        ]),
      )
    ) {
      return true;
    }

    return false;
  }

  handleAlertClose = () => {
    this.setState({
      alert: null,
    });
  };

  renderOverflow = data => {
    const deletable = this.props.serviceKeys[data.value].is_deletable;
    let deleteMenuItemText = 'Löschen';
    if (!deletable) {
      deleteMenuItemText =
        'Leistungskategorie wird verwendet und kann daher nicht gelöscht werden.';
    }

    return (
      <IconMenu
        iconButtonElement={
          <IconButton>
            <MoreVertIcon />
          </IconButton>
        }
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        targetOrigin={{ horizontal: 'right', vertical: 'top' }}
        width="120px"
      >
        <MenuItem
          primaryText="Bearbeiten"
          leftIcon={<EditIcon />}
          onTouchTap={e => this.props.router.push(`/serviceKey/${data.value}`)}
        />
        <Divider />
        <MenuItem
          primaryText={deleteMenuItemText}
          leftIcon={
            <DeleteIcon className="svg-icon-primary svg-icon-warning" />
          }
          key={`delete-service-key-${data.value}`}
          className="menu-primary"
          disabled={!deletable}
          onTouchTap={e => {
            if (deletable) {
              this.setState({
                alert: (
                  <Dialog
                    actions={[
                      <FlatButton
                        label="Abbrechen"
                        primary
                        onTouchTap={this.handleAlertClose}
                      />,
                      <FlatButton
                        label="Löschen"
                        primary
                        onTouchTap={() => {
                          this.handleAlertClose();
                          this.props.deleteServiceKey(data.value);
                          this.props.router.push('/serviceKey');
                        }}
                      />,
                    ]}
                    modal={false}
                    open
                    onRequestClose={this.handleAlertClose}
                  >
                    Leistungskategorie wirklich löschen?
                  </Dialog>
                ),
              });
            }
          }}
        />
      </IconMenu>
    );
  };

  render() {
    const props = this.props;
    const components = {
      NoResults: () => (
        <div>
          <p className="text-center">
            <small>Keine Leistungskategorien eingetragen.</small>
          </p>
        </div>
      ),
    };
    return (
      <div className="wrapper">
        <div>
          <h2 className={`${classes.zenHeader} gutter`}>
            {Object.keys(props.serviceKeys).length} Leistungskategorien
          </h2>

          <Griddle
            data={prepareData(props.serviceKeys, props.fetching)}
            plugins={[plugins.LocalPlugin]}
            pageProperties={{
              pageSize: 5000,
            }}
            components={components}
            sortMethod={caseInsensitiveSort}
          >
            <RowDefinition keyColumn="id">
              <ColumnDefinition
                id="id"
                title="ID"
                cssClassName="text-right"
                visible={false}
              />
              <ColumnDefinition
                id="link"
                title="Leistungskategorie"
                customComponent={renderCell}
                sortMethod={caseInsensitiveSort}
              />
              <ColumnDefinition
                id="typelength"
                title="Leistungsarten"
                sortMethod={caseInsensitiveSort}
              />
              <ColumnDefinition
                id="description"
                title="Beschreibung"
                sortMethod={caseInsensitiveSort}
              />
              <ColumnDefinition id="createdDate" title="hinzugefügt am" />
              <ColumnDefinition
                id="id"
                title=" "
                sortable={false}
                locked
                width="48px"
                customComponent={this.renderOverflow}
              />
            </RowDefinition>
          </Griddle>
        </div>
        {this.state.alert}
      </div>
    );
  }
}
ServiceKey.propTypes = {
  fetchServiceKey: PropTypes.func.isRequired,
  deleteServiceKey: PropTypes.func.isRequired,
  setServiceKeyForm: PropTypes.func.isRequired,
  fetching: PropTypes.bool.isRequired, // eslint-disable-line react/no-unused-prop-types
  serviceKey: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
  serviceKeys: PropTypes.object.isRequired, // eslint-disable-line react/no-unused-prop-types
  params: PropTypes.object.isRequired, // eslint-disable-line react/no-unused-prop-types,
  router: PropTypes.object.isRequired,
  addFeedback: PropTypes.func.isRequired,
};
ServiceKey.defaultProps = {
  fetching: false,
  serviceKey: {},
  serviceKeys: {},
};
export default connect(
  mapStateToProps,
  mapActionCreators,
)(withRouter(ServiceKey));



// WEBPACK FOOTER //
// ./src/routes/ServiceKey/components/ServiceKey.js